import script from "./AudioLearnDataSave.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioLearnDataSave.vue?vue&type=script&setup=true&lang=js"

import "./AudioLearnDataSave.vue?vue&type=style&index=0&id=79f47b95&scoped=true&lang=css"
import "./AudioLearnDataSave.vue?vue&type=style&index=1&id=79f47b95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f47b95"]])

export default __exports__